import React, { useEffect } from "react";
import {  Container, Button } from "react-bootstrap";
import { connect } from "react-redux";
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import "./style.css";
import MaterialTable from 'material-table';
import {  SearchVoucher } from "./Voucher.action";
import { Link } from "react-router-dom";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import {previewVoucher} from '../../../../global/globalFunctions'
const VoucherSearchDetail = (props) => {

    useEffect(() => {
       
    }, []);

    const [state, setState] = React.useState({
        columns: [
            { title: 'Date', field: 'vocDate', render: rowData => moment(rowData.vocDate).format("L") },
            { title: 'Voucher #', field: 'voucherManualId' },
            {title:'Status',field:'status'}
        ],
        columnsData: [
            { title: 'Account Title', field: 'accountTittle' },
            { title: 'Bill No', field: 'billNumber' },
            { title: 'Voucher Description', field: 'voucherDescription' },
            // {title:'Debit',field:'debit'},
            // {title:'Credit',field:'credit'},
            { title: 'Voucher Amount', field: 'voucherAmount', render: rowData => rowData.voucherAmount.toLocaleString() },
            { title: "DR/CR", field: "accountType", render: rowData => rowData.accountType === 1 ? "Credit" : rowData.accountType === 2 ? "Debit" : "" }
         //   { title: "Voucher Date", field: "voucherDate", render: rowData => moment(rowData.voucherDate).format("L") }
        
        ],
    });

    return (
        <>
            {props.isFetchingSearchVoucherList ? (
                <div className="loader-div">
                    <Button variant="info" disabled>
                        <Spinner
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            variant="info"
                        />
                        Loading...
                    </Button>
                </div>
            ) : (
                <Container fluid>
                    <div className="main">

                    <div className="sendDiv">
                            <Link to="/accounts/vouchersearch">
                                <Button > Back to Search</Button>
                            </Link>
                        </div>

                        <div className="table">
                            <MaterialTable
                                title="Voucher Search"
                                columns={state.columns}
                                data={props.searchVoucherList}
                                detailPanel={rowData => {
                                    return (
                                        <MaterialTable
                                            title="Vocuher Details"
                                            columns={state.columnsData}
                                            data={rowData.voucherData}
                                            options={{
                                                actionsColumnIndex: -1,
                                                toolbar: false,
                                                exportButton: true,
                                                sorting: true,
                                                paging: true,
                                                pageSize: 200,       // make initial page size
                                                emptyRowsWhenPaging: false,   // To avoid of having empty rows
                                                pageSizeOptions: [50, 100, 150, 200],
                                                headerStyle: {
                                                    position: 'sticky', top: 0,
                                                    color: '#00BBBB',
                                                    fontWeight: '550',
                                                    onRowAdd: 'none',
                                                }
                                            }}

                                        />
                                    )
                                }}
                                actions={[
                                    {
                                        icon: LocalPrintshopIcon,
                                        disabled: false,
                                        onClick: (event, rowData) => {
                                    previewVoucher(rowData, "Completed",rowData.voucherManualId);
                                        console.log(rowData, "rdata")
                                        },
                                      }
                                ]}
                                options={{
                                    actionsColumnIndex: -1,
                                    filtering: true,
                                    exportButton: true,
                                    paging: true,
                                    pageSize: 200,       // make initial page size
                                    emptyRowsWhenPaging: false,   // To avoid of having empty rows
                                    pageSizeOptions: [50, 100, 150, 200],
                                    headerStyle: {
                                        position: 'sticky', top: 0,
                                        color: '#00BBBB',
                                        fontWeight: '550',
                                        onRowAdd: 'none',
                                    }
                                }}
                         
                                onRowClick={(event, rowData, togglePanel) => togglePanel()}
                            />
                        </div>
                    </div>

                </Container>

            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        SearchVoucher: (data) => dispatch(SearchVoucher(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    searchVoucherList: state.VoucherReducer.searchVoucherList,
    isFetchingSearchVoucherList: state.VoucherReducer.isFetchingSearchVoucherList
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VoucherSearchDetail);